import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Alert from 'containers/common/Alert';
import Header from 'containers/common/Header';
import Footer from 'components/common/Footer';
import Home from 'containers/Home';
import Mypage from 'containers/Mypage';
import OrderAggregators from 'containers/OrderAggregators';
import Faq from 'containers/Faq';
import About from 'containers/About';
import Terms from 'containers/Terms';
import Specified from 'containers/Specified';
import ErrorComponent from 'components/Error';
import ScrollToTop from 'components/common/ScrollToTop';
import Contact from 'containers/Contact';
import Preview from 'containers/Preview';

const App = () => (
  <React.Fragment>
    <Alert />
    <Route
      render={({ location }) =>
        location.pathname !== '/preview' &&
        <Header location={location} />
      }
    />
    <main>
      <ScrollToTop>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/mypage/login" component={Mypage.Login} />
          <Route exact path="/mypage/history" component={Mypage.History} />
          <Route
            exact
            path="/order-aggregators/purchase"
            component={OrderAggregators.Purchase}
          />
          <Route
            exact
            path="/order-aggregators/payment"
            component={OrderAggregators.Payment}
          />
          <Route
            exact
            path="/order-aggregators/confirmation"
            component={OrderAggregators.Confirmation}
          />
          <Route
            exact
            path="/order-aggregators/completion"
            component={OrderAggregators.Completion}
          />
          <Route exact path="/about/payment" component={About.Payment} />
          <Route exact path="/about/delivery" component={About.Delivery} />
          <Route exact path="/about/gift" component={About.Gift} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/faq" component={Faq} />
          <Route exact path="/specified" component={Specified} />
          <Route exact path="/error" component={ErrorComponent} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/preview" component={Preview} />
          <Route component={ErrorComponent} />
        </Switch>
      </ScrollToTop>
    </main>
    <Route
      render={({ location }) =>
        !location.pathname.includes('/order-aggregators') &&
        location.pathname !== '/preview' &&
        <Footer />
      }
    />
  </React.Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js